<template>
    <div>
        <v-expansion-panel 
            v-model="open"
            :expand="expand"
            :focusable="focusable"
            class="content-spacing"
            @input="index => { $emit('openPanel',  items[index]) }"
        >
            <v-expansion-panel-content
                v-for="(item, i) in filteredItems"
                :key="i"
                :hide-actions="hideActions"
                :expand-icon="'expansion-icon-size ' + expandIconClass(i)"
                v-show="filter(item)"
                @input="isOpened => { $emit('togglePanel', {item, isOpened, index: i}) }"
            >
                <div slot="header">
                    <slot 
                        name="header" 
                        v-bind="{ item, index: i }"
                    ></slot>
                </div>
                <slot 
                    name="content" 
                    v-bind="{ item, index: i }"
                ></slot>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>
<script>
export default {
    computed: {
        searchValues: function(){
            const self = this
            return this.items.map( i => self.searchKeys.map( k => i[k].toString().toLowerCase() ).join(' ') )
        },
        filteredItems: function() {
            return this.searchQuery ? this.filterValues(this.searchQuery) : this.items
        }
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        iconClassModifier: {
            type: String,
            required: true
        },
        hideActions: Boolean,
        expand: {
            type: Boolean,
            default: false
        },
        focusable: {
            type: Boolean,
            default: false
        },
        searchQuery: {
            type: String,
            default: ''
        },
        searchKeys: {
            type: Array
        },
        filter: {
            type: Function,
            default: () => true
        },
        openedOnReload:{
            type: Boolean
        }
    },
    data() {
        return {
            open: null,
            panels: [],
        }
    },
    methods: {
        toggleItem(index) {
            if(this.expand){
                this.open[index] = !this.open[index]
                this.open = [...this.open]
            }else{
                this.open = index
            }
        },
        expandIconClass: function (i) {
            const value = this.open != null ? (Array.isArray(this.open) ? this.open[i] : this.open === i) : false
            return `bexsicon-${value
                    ? 'minus' 
                    : 'plus' 
                } ${this.iconClassModifier}`
        },
        filterValues: function (query){
            query = query.toLowerCase() 
            const items = this.items
            const indexes = []
            this.searchValues.forEach((v, index) => {
                if(v.includes(query)){
                    indexes.push(index)
                }
            })
            const filteredItems = indexes.map(i => items[i])
            this.$emit('filteredItemsLength', filteredItems.length)
            return filteredItems
        }
    },
    watch: {
        items(value){
            if(!this.openedOnReload){
                this.open = [...Array(this.items).keys()].map(_ => false)
            }
        }
    }
}
</script>
<style lang="scss">

.content-spacing {
    border: none !important;
    box-shadow: none !important;

    > * {
        display: block;
        margin-top: .7em;
        box-shadow: var(--box-shadow);
    }

    > *:first-child {
        margin-top: 0px;
    }

    .v-card {
        box-shadow: none !important;
    }

    .v-expansion-panel__container {
        border: none !important;
        border-radius: 3px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/layout/ExpansionPanelList.vue